"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    cpqWelcomeTitle: {
        id: 'cpq.welcomeTitle',
        defaultMessage: 'Welcome to AGCO Configurator',
        description: 'Main title for the CPQ welcome page',
    },
    cpqChooseYourBrand: {
        id: 'cpq.chooseYourBrand',
        defaultMessage: 'Choose your brand',
        description: 'Label for the brand selection field',
    },
});
exports.default = messages;
